import React, { FC, memo, useCallback } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { EEventsFacets } from '@ucheba/store/events/search/types'
import { useRouter } from '@ucheba/utils/hooks/useRouter'
import { searchQueryByEventsFacet } from '../constants'
import { useEventsPageSelectedFacets } from '../bll'

const Block = styled.div`
  margin-bottom: -${sv.spacing.xsmall};
`
const Chip = styled(Chips)`
  margin-right: ${sv.spacing.xsmall};
  margin-bottom: ${sv.spacing.xsmall};
`

const EventsSelectedPageFacets: FC = () => {
  const { selectedFacets, removeFacet } = useEventsPageSelectedFacets()
  const router = useRouter()

  /* Сбрасывает все выбранные фасеты */
  const resetFacets = useCallback(() => {
    router.push(
      stringifyUrl(router.asPath, {
        exclude: Object.keys(EEventsFacets).map(
          (facetName) => searchQueryByEventsFacet[facetName]
        ),
      })
    )
  }, [router])

  const onRemoveFacet = (queryKey, id) => () => removeFacet(queryKey, id)

  if (!selectedFacets.length) return null

  return (
    <Block>
      {selectedFacets.map(({ name, value, queryKey }) => (
        <Chip
          color='blue'
          clear
          onClick={onRemoveFacet(queryKey, value)}
          firstLetterUppercase
          key={queryKey + value}
        >
          {name}
        </Chip>
      ))}

      <Button size='small' view='link' onClick={resetFacets}>
        Сбросить все фильтры
      </Button>

      <Spacing spacing='xlarge' />
    </Block>
  )
}

export default memo(EventsSelectedPageFacets)
